import React, { FC, useRef } from 'react';
import { Box } from '@withjoy/joykit';
import { CroppedImageProps } from './CroppedImage.types';
import { useDrawCroppedImageToCanvas } from '@apps/guest/packages/layout-engine/layouts/LayoutBrannan/components/HeaderV2/components/ProgressiveImage/CroppedProgressiveImage/useDrawCroppedImageToCanvas';

export const CroppedImage: FC<CroppedImageProps> = props => {
  const { imageUrl, cropInfo, width, height, canvasStyles = {} } = props;

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const { hasError } = useDrawCroppedImageToCanvas({ canvasRef, cropInfo, height, width, imageUrl });

  // Fallback to background image if there's an error
  if (hasError) {
    return (
      <Box
        width={width}
        height={height}
        overflow="hidden"
        background={`url("${imageUrl}") lightgray 50%`}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      />
    );
  }

  return <Box as="canvas" ref={canvasRef} width={width} height={height} overflow="hidden" display="block" background="lightgray" {...canvasStyles} />;
};

CroppedImage.displayName = 'CroppedImage';
